import { compose } from "redux";
import { firstChar, toLowerCase } from "./fp";

const combiningDiacriticalMarks = /[\u0300-\u036f]/g;

const withoutCombiningDiacriticalMarks = str =>
  str.normalize("NFD").replace(combiningDiacriticalMarks, "");

export default compose(
  withoutCombiningDiacriticalMarks,
  toLowerCase,
  firstChar
);
